<div class="row mt-2 mr-0 ml-0">
    <div class="col-12 text-center">
        <app-sigma-dashboard [embedUrl]="sigmaUrl"></app-sigma-dashboard>
    </div>
</div>